module.exports = __webpack_public_path__ + "img/plant_6.ac614200.webp";